import React, { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import Loader from '../components/loader'
import { AccountContext } from '../context/account'

interface Props {
  children: React.ReactNode
  redirectWhenLoggedIn?: boolean
}

const PublicRoute = ({ children, redirectWhenLoggedIn = true }: Props) => {
  const { account } = useContext(AccountContext)

  if (!account.checked) {
    return <Loader center middle />
  }

  // Replaces the old useEffect + navigate('/dashboard'). Returning <Navigate>
  // during render is the v6 idiom and avoids the brief flash of the public page.
  if (account.loggedIn && redirectWhenLoggedIn) {
    return <Navigate to="/dashboard" replace />
  }

  return <>{children}</>
}

export default PublicRoute